import React from 'react';
import { Radio } from '@atlaskit/radio';
import { SubscriptionsByBillDate } from '../../../subscriptions-by-bill-date';
import { EntitlementDetails, EntitlementGroup } from '@css-xp/graphtypes/src/generated-types-new';
import EmptyState from '@atlaskit/empty-state';
import DismissableInlineMessage, { StyledTitle } from '../../../dismissable-inline-message';
import '../set-co-bill-date.scss';
import './co-billing-component.scss';

export interface CoBillingProps {
  billingDateGroup: EntitlementGroup[] | undefined;
  product: any;
  selectedBillingDate?: string;
  handleBillDateChange?: (data: any) => void;
  radioValue?: string;
  setRenewelDate?: (data: any) => void;
  renewelDate?: string;
  quotePage?: boolean;
  isTermed?: boolean;
}

export const CoBillingCommon = ({
  billingDateGroup,
  product,
  selectedBillingDate,
  handleBillDateChange,
  radioValue,
  setRenewelDate,
  renewelDate,
  quotePage = false,
  isTermed = false,
}: CoBillingProps) => {
  let totalEntitlementsCounts = 0;

  const setDateSelection = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (quotePage) {
      setRenewelDate && setRenewelDate(e.currentTarget.value);
    } else {
      handleBillDateChange && handleBillDateChange(e);
    }
  };

  const subscriptionsOnBillDate = () => {
    const selectedDateValue = radioValue ?? selectedBillingDate;

    const subscriptionsOnDate = billingDateGroup?.map((group: EntitlementGroup) => {
      const { billingDate, entitlements = [] } = group as EntitlementGroup;
      const filteredEntitlements = (entitlements as EntitlementDetails[]).filter(
        (item) => item?.entitlementNumber !== product?.entitlementNumber
      );
      totalEntitlementsCounts += filteredEntitlements.length;

      return (
        filteredEntitlements.length > 0 && (
          <div className="subscription-billing-container">
            <div className="radio-button-container">
              <Radio
                isChecked={billingDate === (quotePage ? renewelDate : selectedDateValue)}
                onChange={(event) => setDateSelection(event)}
                name={`key_${billingDate}`}
                value={billingDate ?? ''}
                testId="set-billing-date"
              />
            </div>
            <SubscriptionsByBillDate
              key={`key_${billingDate}`}
              billingDate={billingDate as string}
              entitlements={filteredEntitlements}
              focused={billingDate === selectedDateValue}
              isTermed={isTermed}
            />
          </div>
        )
      );
    });

    if (totalEntitlementsCounts === 0) {
      return (
        <>
          <EmptyState header={'No available subscriptions'} />
          <DismissableInlineMessage
            position="bottom-start"
            renderMessage={() => (
              <p className="inline-message">
                Not all billing profiles are supported for this subscription. Change the plan details to use an existing
                billing profile or create a new one with a different payment method
              </p>
            )}
            renderTitle={(toggleMessage: () => void) => (
              <span className="hoverable-icon" onClick={toggleMessage}>
                <StyledTitle title="Can’t find the subscriptions you’re looking for?" type="info" size="medium" />
              </span>
            )}
          />
        </>
      );
    }

    return (
      <>
        {subscriptionsOnDate}
        <DismissableInlineMessage
          position="bottom-start"
          renderMessage={() => (
            <p className="inline-message">
              Not all billing profiles are supported for this subscription. Change the plan details to use an existing
              billing profile or create a new one with a different payment method
            </p>
          )}
          renderTitle={(toggleMessage: () => void) => (
            <span className="hoverable-icon" onClick={toggleMessage}>
              <StyledTitle title="Can’t find the billing profile you’re looking for?" type="info" size="medium" />
            </span>
          )}
        />
      </>
    );
  };
  return <>{<div>{subscriptionsOnBillDate()}</div>}</>;
};
